import { useContext } from 'react';

import { MainContext, redirectToUrl, useTranslation } from '@ezbobdev/ui-framework';
import {
  MaterialButton,
  MaterialDialogActions,
  MaterialDialogContent,
  MaterialDialogTitle,
  MaterialTypography,
} from '@ezbobdev/ui-widgets-ezbob';

import { systemEvents } from '../../utils/constants';
import { StyledMaterialDialog } from './TerminateFlowDialog.styled';

const TerminateFlowDialog = (props) => {
  const { actions, sdkActions } = useContext(MainContext);
  const { open, onClose } = props;

  const { getUserConfigProp } = actions.settings;

  const { t } = useTranslation();

  const url = getUserConfigProp(`product.url`);

  const handleCancelCase = async () => {
    actions.events.emit(systemEvents.GL_ABANDON);
    await sdkActions.case.cancel();
    redirectToUrl(url);
  };

  return (
    <StyledMaterialDialog
      open={open}
      onClose={onClose}
      fullWidth={true}
      className="TerminateFlowDialog"
      withDivider={false}
      dialogTitle={
        <MaterialDialogTitle disableTypography withDivider={false} onClose={onClose}>
          <MaterialTypography variant="h1" component="h2">
            {t('terminateFlowDialog.title')}
          </MaterialTypography>
        </MaterialDialogTitle>
      }
      dialogActions={
        <MaterialDialogActions disableSpacing>
          <MaterialButton variant="contained" onClick={onClose}>
            {t('terminateFlowDialog.cancel')}
          </MaterialButton>
          <MaterialButton onClick={handleCancelCase} variant="outlined">
            {t('terminateFlowDialog.submit')}
          </MaterialButton>
        </MaterialDialogActions>
      }
    >
      <MaterialDialogContent>
        <MaterialTypography>{t('terminateFlowDialog.text')}</MaterialTypography>
      </MaterialDialogContent>
    </StyledMaterialDialog>
  );
};

export default TerminateFlowDialog;
